/** @format */

export const productNavigationMenu = [
    {
        title: 'Terms of Service',
        link: '/tos',
        altLink: '/tos',
        type: 'absolute'
    },
    {
        title: 'Privacy',
        link: '/privacy',
        altLink: '/privacy',
        type: 'absolute'
    },
    {
        title: 'Security',
        link: '/security',
        altLink: '/security',
        type: 'absolute'
    },
    {
        title: 'Cancellation Policy',
        link: '/cancellation_policy',
        altLink: '/cancellation_policy',
        type: 'absolute'
    },
    {
        key: 'EzClocker_Online_Status',
        title: 'EzClocker Online Status',
        link: 'https://status.ezclocker.com/',
        altLink: 'https://status.ezclocker.com/',
        type: 'absolute'
    }
];
